import React from 'react';
import { DOCS_LINKS } from 'common/data/launch';
import { PlansBox, TableScroll, PlansTable, Terms, Closing } from './plans.style';

const ROWS = [
  ['Savings Scan across all supported services', 'Yes', 'Yes'],
  ['Overview and savings flow diagram', 'Yes', 'Yes'],
  ['Per-service savings totals', 'Yes', 'Yes'],
  [
    'Click-to-pin drill-down on the diagram',
    'Aggregate figures only',
    'Names the affected resources',
  ],
  ['Opportunities list, searchable and sortable', 'Not included', 'Included'],
  ['Evidence and recommended action per finding', 'Not included', 'Included'],
  ['History of saved runs', 'Summary records', 'Full history'],
  ['Export of runs', 'Not included', 'Included'],
  [
    'Agentic FinOps',
    'Built-in MCP server for your AI Agents',
    'Adds run history and per-opportunity detail',
  ],
];

const PlansSection = () => (
  <PlansBox id="plans">
    <h3 className="compare">Compare Free and Pro</h3>

    <TableScroll>
      <PlansTable>
        <thead>
          <tr>
            <th scope="col">What you get</th>
            <th scope="col">Free (basic plan)</th>
            <th scope="col">Pro (every paid plan, and the Pro trial)</th>
          </tr>
        </thead>
        <tbody>
          {ROWS.map(([what, free, pro]) => (
            <tr key={what}>
              <th scope="row">{what}</th>
              <td data-label="Free (basic plan)">{free}</td>
              <td data-label="Pro (every paid plan, and the Pro trial)">{pro}</td>
            </tr>
          ))}
        </tbody>
      </PlansTable>
    </TableScroll>

    <Terms>
      <p>Free, the basic plan, never expires, and registering takes an e-mail address.</p>
      <p>
        The Pro trial gives you Pro for 7 days, counted from registration, and
        needs no credit card.
      </p>
      <p>
        When a Pro trial ends, CloudPouch moves to Free automatically, the next
        time you start the app. A notice titled "Your Pro trial has ended" offers Continue on
        Free or Upgrade to Pro. Savings Scans and the built-in MCP server
        keep working with summary savings, and per-resource detail stays locked
        until you upgrade.
      </p>
    </Terms>

    <Closing>
      <h3>Good to know</h3>
      <ul>
        <li>
          Runs saved on Free stay summary-only after an upgrade. One fresh
          Savings Scan on Pro restores full detail from then on.
        </li>
        <li>
          A new license key takes effect as soon as you choose Save &amp;
          validate in Settings. Other plan changes, such as the end of a
          trial, apply the next time you start the app.
        </li>
      </ul>
      {/* Docs are a separate release: check this URL returns 200 first. */}
      <a href={DOCS_LINKS.limitations}>See all limitations</a>
    </Closing>
  </PlansBox>
);

export default PlansSection;
